import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ProfileDisplays } from 'src/app/models/profile-display.t';
import { ApplicationService } from 'src/app/services/application.service';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { TokenStorageService } from '../../services/token-storage/token-storage.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit, OnDestroy {

  selected = new FormControl(0);
  onDestroy$ = new Subject<void>();
  id: string = '';

  data: ProfileDisplays[] = [];

  constructor(
    public applicationService: ApplicationService,
    private profileService: ProfileService,
    private route: ActivatedRoute,
    private tokenStorageService: TokenStorageService,
  ) { }

  ngOnInit(): void {
    this.route.paramMap.pipe(takeUntil(this.onDestroy$)).subscribe((params) => {
      this.id = params.get('profileId') || this.tokenStorageService.getId();
      this.applicationService.currentProfileId$.next(this.id);
      this.profileService.getProfileDisplay(this.id)
        .subscribe((data) => {
          this.data = data.profileDisplays;
        })
    });
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
